import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client, useScopedMerchantClient } from "./scoped-merchant-client";

export const useTikTokAdsAuthUrl = (enabled = true) => {
  const scope = useScopedMerchantClient();
  return useQuery({
    queryKey: ["tts-ads", "auth-url", scope.merchantId, scope.workspaceId],
    queryFn: async () => {
      if (!scope.merchantId) return null;
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"]["tts-ads"]["auth-url"].$get({
            param: scope.param,
          })
        : await client.merchant[":merchantId"]["tts-ads"]["auth-url"].$get({
            param: scope.param,
          });
      if (!res.ok) throw await handleError(res);
      return res.json();
    },
    select: (data) =>
      data
        ? {
            ...data,
            authUrl: data.explainerUrl,
            consentUrl: data.authUrl,
          }
        : data,
    enabled: !!scope.merchantId && enabled,
    staleTime: 5 * 60 * 1000,
  });
};

export const useTikTokAdsConnectionStatus = (
  enabled = true,
  options?: { refetchInterval?: number | false; stats?: boolean },
) => {
  const scope = useScopedMerchantClient();
  const stats = options?.stats === true;
  return useQuery({
    // `stats` belongs in the key: every consumer shares this query, and a cached
    // response without the stats would otherwise satisfy the row that renders them.
    queryKey: ["tts-ads", "connection-status", scope.merchantId, scope.workspaceId, stats],
    queryFn: async () => {
      if (!scope.merchantId) return null;
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"]["tts-ads"]["connection-status"].$get({
            param: scope.param,
            query: stats ? { stats: "true" } : {},
          })
        : await client.merchant[":merchantId"]["tts-ads"]["connection-status"].$get({
            param: scope.param,
            query: stats ? { stats: "true" } : {},
          });
      if (!res.ok) throw await handleError(res);
      return res.json();
    },
    enabled: !!scope.merchantId && enabled,
    staleTime: 30 * 1000,
    refetchInterval: options?.refetchInterval,
    refetchOnWindowFocus: true,
  });
};
